export default __webpack_public_path__ + "static/Litepaper - Turkish-8c038ce83fbeb5f90be198d7381cc010.pdf";